import className from 'classnames/bind';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import Heading from 'components/shared/heading';
import useDeviceType, { DEVICE_TYPE } from 'hooks/use-device-type';
import Arrow from 'images/pages/home/resources/arrow.inline.svg';
import Pictogram from 'images/pages/home/resources/pictogram.inline.svg';
import SearchIcon from 'images/pages/home/resources/search.inline.svg';

import styles from './resources.module.scss';
import Spotlight from './spotlight';

const cx = className.bind(styles);

const BULLETS_TEXT = [
  'People resell all over, but the barrier to get to the highest level is too great',
  "We're breaking down the walls and making it easier than ever to go from zero to hero",
];

const Resources = () => {
  const [sectionRef, inView] = useInView({});

  const deviceType = useDeviceType();

  const disableSpotlightAnimation = deviceType !== DEVICE_TYPE.desktop;

  return (
    <section className={cx('container', 'resources')} ref={sectionRef} id="spotlight-container">
      {deviceType === DEVICE_TYPE.desktop && (
        <>
          <Heading
            className={cx('title', 'title-visible')}
            tag="h2"
            size="xl"
            theme="secondary-inverted"
          >
            Resources are<span className={cx('title-transparent')}> hard</span>
          </Heading>
          <Heading className={cx('title')} tag="h2" size="xl" theme="secondary-inverted">
            <span className={cx('title-transparent')}>Resources are</span>
            <span className={cx('text')}> hard to find</span>
          </Heading>
        </>
      )}
      {deviceType === DEVICE_TYPE.tablet.portrait && (
        <>
          <Heading
            className={cx('title', 'title-visible')}
            tag="h2"
            size="xl"
            theme="secondary-inverted"
          >
            Resour&#8209;
            <br />
            ces are
            <span className={cx('dim')}> hard to find</span>
          </Heading>
        </>
      )}

      {deviceType === DEVICE_TYPE.mobile.portrait && (
        <Heading
          className={cx('title', 'title-visible')}
          tag="h2"
          size="xl"
          theme="secondary-inverted"
        >
          <span>Resou&#8209;</span>
          <span>rces</span>
          <span>are</span>
          <span className={cx('dim')}>hard</span>
          <span className={cx('dim')}>to</span>
          <span className={cx('dim')}>find</span>
        </Heading>
      )}

      {(deviceType === DEVICE_TYPE.mobile.landscape ||
        deviceType === DEVICE_TYPE.tablet.landscape) && (
        <Heading
          className={cx('title', 'title-visible')}
          tag="h2"
          size="xl"
          theme="secondary-inverted"
        >
          <span>Resources are</span>
          {deviceType === DEVICE_TYPE.tablet.landscape && <span> </span>}
          <span className={cx('dim')}>hard to find</span>
        </Heading>
      )}

      <div className={cx('bullets')}>
        <div className={cx('bullets-inner')}>
          <div className={cx('bullets-item')}>
            <span>{BULLETS_TEXT[0]}</span>
          </div>
          <Arrow className={cx('arrow')} />
          <div className={cx('bullets-item')}>
            <span>{BULLETS_TEXT[1]}</span>
          </div>
        </div>
      </div>

      <Pictogram className={cx('pictogram')} />
      <SearchIcon className={cx('search-icon')} />
      {!disableSpotlightAnimation && <Spotlight inView={inView} />}
    </section>
  );
};

export default Resources;
